var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAgree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.16 13.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4f97a9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30DE\\u30A6\\u30B9\\u30AA\\u30F3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1.71,
    cy: 7.49,
    rx: 1.62,
    ry: 1.8,
    transform: "translate(-4.77 3.36) rotate(-44.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 3.49,
    cy: 3.3,
    rx: 1.81,
    ry: 2.14,
    transform: "translate(-1.07 1.78) rotate(-24.93)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 11.53,
    cy: 4.92,
    rx: 1.8,
    ry: 1.62,
    transform: "translate(3.73 14.74) rotate(-74.64)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 7.93,
    cy: 2.14,
    rx: 1.81,
    ry: 2.14,
    transform: "translate(-0.14 0.61) rotate(-4.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.21,11.8A7.53,7.53,0,0,1,10,11.55c.52,0,1,.1,1.55,0a1.91,1.91,0,0,0,1.32-.74c.78-1-.26-2.27-1.11-2.79a28.68,28.68,0,0,1-3-2.1,2.44,2.44,0,0,0-2.42-.62A2.78,2.78,0,0,0,4.94,6.94a27.45,27.45,0,0,1-1.61,3.32c-.49.87-.78,2.47.4,3a1.86,1.86,0,0,0,1.5,0c.48-.2.89-.55,1.34-.79a7.36,7.36,0,0,1,1.64-.64Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgree);
export default __webpack_public_path__ + "static/media/icon-agree.aac760ef34f37df7b611c763dcee7e90.svg";
export { ForwardRef as ReactComponent };